import React, { useEffect, useState } from "react";
import styles from "./navigationMobile.scss";
import { ArrowUp, ArrowDown } from "../../assets/icons/navigation/index";
import { getQueryUTMString } from '@tw/shared-ui-components/lib/utils/helper';
const NavigationMobile = ({
  className,
  navigationMenus = [],
  Link,
  type = "product",
  cs,
  hamburgerClickHandler,
}) => {
  const NextLink = Link || "a";
  const [menus, setMenus] = useState([]);
  const baseURL = "/category/";
  let param = getQueryUTMString('?');
  useEffect(() => {
    // navigationMenus[0].expanded = true
    setMenus(navigationMenus);
  }, [navigationMenus]);

  const handleExpand = (code) => {
    let newMenus = menus.map((catItem) => {
      if (catItem.code === code) catItem.expanded = !catItem.expanded;
      return catItem;
    });
    setMenus(newMenus);
  };
  const integratedBrowserUTMParameters = (item) => {
    if (item.redirectUrl) {
      if ((item.redirectUrl?.includes("?"))) {
        return `${item.redirectUrl}&navigationType=${item?.type}${param}`
      } else {
        return `${item.redirectUrl}?navigationType=${item?.type}${param}`
      }
    } else {
      return `${baseURL}${item.code}?navigationType=${item?.type}${param}`
    }
  }
  const processedMenus = () => {
    let menuList = [];
    menus.forEach((item) => {
      if (type === "discover")
        menuList.push(
          <div
            key={`navCat-${item.code}`}
            className={`${styles.catItem} `}
            onClick={hamburgerClickHandler}
          >
            <NextLink
              href={
                integratedBrowserUTMParameters(item)
              }
              passHref
            >
              <a>
                <div className={styles.imgContainer}>
                  <img src={item.icon} />
                </div>
                <div>{item.name}</div>
              </a>
            </NextLink>
          </div>
        );
      else {
        menuList.push(
          <div
            key={`navCat-${item.code}`}
            onClick={() => handleExpand(item.code)}
            className={`${styles.catItem}`}
          >
            <div className={styles.imgContainer}>
              <img src={item.icon} />
            </div>
            <div>{item.name}</div>
            <img
              className={`${styles.expandIcon} ${item.expanded ? styles.edgeEnd : ""
                }`}
              src={ArrowDown.default}
            />
          </div>
        );

        if (item.expanded)
          menuList.push(
            <div
              key={`navSubCatContainer-${item.code}`}
              className={styles.subCategory}
            >
              {item.subCategories.map((subItem) => {
                return (
                  <div
                    key={`navSubCat-${subItem.code}`}
                    className={styles.subCatItem}
                    onClick={hamburgerClickHandler}
                  >
                    <NextLink
                      href={
                        integratedBrowserUTMParameters(subItem)
                      }
                      passHref
                    >
                      <a>{subItem.name}</a>
                    </NextLink>
                  </div>
                );
              })}
              <div
                className={styles.subCatItem}
                onClick={hamburgerClickHandler}
              >
                <NextLink
                  href={
                    item?.redirectUrl ?
                      (item?.redirectUrl?.includes("?")) ?
                        `${item?.redirectUrl}&navigationType=${item?.type}${param}` :
                        `${item?.redirectUrl}?navigationType=${item?.type}${param}` :
                      `${baseURL}${item.code}?navigationType=${item?.type}${param}`
                  }
                  passHref
                >
                  <a>檢視全部產品</a>
                </NextLink>
              </div>
            </div>
          );
      }
    });

    return menuList;
  };

  return (
    <div
      className={`${styles.container} ${styles[className]}`}
      style={{
        paddingBottom:
          document.getElementsByClassName(
            "announcement-bar__announcement_bar_container"
          )?.[0]?.offsetHeight || 0,
      }}
    >
      <div className={styles.category}>{processedMenus()}</div>
      <div className={styles.footer}>
        {cs.map((item, index) => {
          return (
            <div className={styles.link} onClick={hamburgerClickHandler} key={`cs_${index}`}>
              <NextLink href={item.targetUrl.link.href || "/"} passHref>
                <a>
                  <img src={item.icon} />
                  <span>{item.title}</span>
                </a>
              </NextLink>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default NavigationMobile;
